import { FaSearch,FaBars } from "react-icons/fa"
import  './Header.css'
import { useState } from "react"

const Header = () => {
const [toggle,setToggle] = useState(false)
const adminOnly = () =>{
    alert("Only admin have access")
  }
/* 
const searchIcon = () =>{
  alert("No data available to search!!! ")
}
   */
const handleToggle = ()=>{
  setToggle(!toggle)

  
}
  return (
    <header>
        <nav onClick={adminOnly} className="bar-icon-and-section">
            <FaBars/>
            <p>Sections</p>
        </nav>
        <nav className="new-name">Arkansas News</nav>
        <div className="subcribe-login-search">
        <nav onClick={handleToggle} className= {`subscribe-button ${toggle?"subscribe-button2":""}`} >{toggle?"SUBSCRIBED":"SUBSCRIBE"}</nav>
        <nav className="log">LOG IN</nav>
         <nav><a  href="https://www.google.com" 
      target="_blank" 
      rel="noopener noreferrer"><FaSearch/>   </a></nav>
        </div>
        
     </header>
  )
}

export default Header